import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { CreateConference } from "~pages/Conferences/types/upsertConference.ts";
import type { ConferenceResponse } from "~types/conference.ts";

export const useCreateConference = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<ConferenceResponse | undefined, Error, CreateConference>({
    mutationFn: async (data) => {
      return await request<ConferenceResponse>(`${sport}/o/${organizationId}/conferences`, {
        method: "POST",
        body: data,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["conferences"] });
    },
  });
};
